import { useEffect, useState } from "react";
import { Gate } from "../permissions/PermissionContext";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { Badge, ConfirmModal, Spinner } from "../components/UI";
import dayjs from "dayjs";
import "dayjs/locale/de";
dayjs.locale("de");

export default function SitzungenList() {
  const [sitzungen, setSitzungen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [filter, setFilter] = useState("alle");
  const navigate = useNavigate();

  const load = () => api.getSitzungen().then(setSitzungen).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleDelete = async () => {
    await api.deleteSitzung(deleteId);
    load();
  };

  const filtered = filter === "alle" ? sitzungen :
    sitzungen.filter(s => s.status === filter);

  if (loading) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="breadcrumb">Sitzungen</div>
          <h2>Alle Sitzungen</h2>
        </div>
        <div className="page-actions">
          <Gate perm="sitzung.erstellen"><Link to="/sitzungen/neu" className="btn btn-primary">+ Neue Sitzung</Link></Gate>
        </div>
      </div>

      <div className="content">
        {/* Filter */}
        <div className="flex gap-8 mb-16">
          {["alle", "geplant", "eingeladen", "durchgefuehrt", "abgesagt", "geschlossen_beschlussunfaehig"].map(f => (
            <button
              key={f}
              className={`btn btn-sm ${filter === f ? "btn-primary" : "btn-secondary"}`}
              onClick={() => setFilter(f)}
            >
              {f === "alle" ? "Alle" :
               f === "geplant" ? "Geplant" :
               f === "eingeladen" ? "Eingeladen" :
               f === "durchgefuehrt" ? "Durchgeführt" : f === "abgesagt" ? "Abgesagt" : "Beschlussunfähig"}
            </button>
          ))}
        </div>

        <div className="card">
          {filtered.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📋</div>
              <p>Keine Sitzungen vorhanden</p>
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Aktenzeichen</th>
                  <th>Sitzung</th>
                  <th>Gremium</th>
                  <th>Datum</th>
                  <th>Ort</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(s => (
                  <tr key={s.id} style={{ cursor: "pointer" }} onClick={() => navigate(`/sitzungen/${s.id}`)}>
                    <td style={{ fontFamily: "var(--mono)", fontSize: 12, color: "var(--red)", fontWeight: 600 }}>{s.aktenzeichen || "—"}</td>
                    <td><strong>{s.titel}</strong>{s.status === "abgesagt" && s.absage_begruendung && <div style={{ fontSize: 11, color: "var(--danger)", marginTop: 2 }}>✕ {s.absage_begruendung}</div>}</td>
                    <td style={{ color: "#666" }}>{s.gremium?.name}</td>
                    <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>
                      {dayjs(s.datum).format("DD.MM.YYYY HH:mm")}
                    </td>
                    <td style={{ color: "#666" }}>{s.ort || "—"}</td>
                    <td><Badge status={s.status} /></td>
                    <td onClick={e => e.stopPropagation()}>
                      <div className="actions">
                        <Link to={`/sitzungen/${s.id}`} className="btn btn-ghost btn-sm btn-icon" title="Bearbeiten" aria-label="Bearbeiten">✎</Link>
                        <button className="btn btn-ghost btn-sm btn-icon" title="Löschen" aria-label="Löschen" onClick={() => setDeleteId(s.id)}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {deleteId && (
        <ConfirmModal
          message="Sitzung wirklich löschen? Alle TOPs und Protokolleinträge werden ebenfalls gelöscht."
          onConfirm={handleDelete}
          onClose={() => setDeleteId(null)}
        />
      )}
    </div>
  );
}
